"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _index = require("../../../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CaraouselItem = props => {
  var _props$title, _props$headerTitle, _props$description, _props$image, _props$buttonText;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const headerTitle = (_props$headerTitle = props === null || props === void 0 ? void 0 : props.headerTitle) !== null && _props$headerTitle !== void 0 ? _props$headerTitle : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const image = (_props$image = props === null || props === void 0 ? void 0 : props.image) !== null && _props$image !== void 0 ? _props$image : "";
  const buttonText = (_props$buttonText = props === null || props === void 0 ? void 0 : props.buttonText) !== null && _props$buttonText !== void 0 ? _props$buttonText : "";
  const handleButtonClick = props === null || props === void 0 ? void 0 : props.handleButtonClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-block w-100 pagination-carousel-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row py-4 w-100 mx-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-7"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "hero-section-font-white heading-medium-large fw-normal"
  }, headerTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "pc-title-highlighter"
  }), /*#__PURE__*/_react.default.createElement("h1", {
    className: "hero-section-font-white pt-3 heading-xx-medium-large"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "fw-normal heading-medium hero-section-font-white pt-1"
  }, description), /*#__PURE__*/_react.default.createElement(_index.SVBButton, {
    rightIconExtraClasses: "exploreApi-button-icon",
    extraClasses: "border-0 hero-section-button",
    text: buttonText,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "down",
    iconSide: "right",
    onClick: () => handleButtonClick()
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-5 text-align-left d-flex align-content-start align-items-start"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    className: "w-100"
  }))));
};
const SVBHeaderCarousel = props => {
  const {
    data
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "carouselExampleIndicators",
    className: "carousel slide"
    // data-bs-interval={false} //to enable autoplay with value in ms.
    // data-bs-ride="carousel" //enable this for autoplay
  }, data && (data === null || data === void 0 ? void 0 : data.length) > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "carousel-indicators"
  }, data === null || data === void 0 ? void 0 : data.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "pagination-carousel-dots ".concat(index === 0 ? "active" : ""),
      type: "button",
      "data-bs-target": "#carouselExampleIndicators",
      "data-bs-slide-to": index,
      "aria-current": "true",
      "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.title, "-").concat(index)
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "carousel-inner"
  }, data === null || data === void 0 ? void 0 : data.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-item ".concat(index === 0 ? 'active' : ''),
      key: index
    }, /*#__PURE__*/_react.default.createElement(CaraouselItem, item));
  }))));
};
var _default = SVBHeaderCarousel;
exports.default = _default;